const weatherWidget = (editor) => {

    editor.BlockManager.add('weatherWidget', {
        category: 'Built In Components',
        label: 'Weather Widget',
        attributes: {},
        content: `
          <div class="row d-flex justify-content-center align-items-center p-4">
            <div class="col-md-8 col-lg-6 col-xl-4">
      
              <div class="card rounded-lg bg-light shadow">
                <div class="card-body p-4">
      
                  <div class="d-flex">
                    <h6 class="flex-grow-1">Warsaw</h6>
                    <h6>15:07</h6>
                  </div>
      
                  <div class="d-flex flex-column text-center mt-5 mb-4">
                    <h6 class="display-4 mb-0 fw-bold text-dark" > 13°C </h6>
                    <span class="small text-secondary" >Stormy</span>
                  </div>
      
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1" >
                      <div><i class="bi-wind text-secondary" ></i> <span class="ms-1"> 40 km/h
                        </span></div>
                      <div><i class="bi-droplet-fill text-secondary" ></i> <span class="ms-1"> 84% </span>
                      </div>
                      <div><i class="bi-sun-fill text-secondary" ></i> <span class="ms-1"> 0.2h </span>
                      </div>
                    </div>
                    <div>
                      <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-weather/ilu1.webp"
                        width="100px">
                    </div>
                  </div>
      
                </div>
              </div>
      
            </div>
          </div>
        `
    })
};

export default weatherWidget;